/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Distillation_Success_Artifact_CreatedInputs */



/**
* | output |
* | --- |
* | "Artifact \"{name}\" created successfully" |
*
* @param {Distillation_Success_Artifact_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const distillation_success_artifact_created = /** @type {((inputs: Distillation_Success_Artifact_CreatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Distillation_Success_Artifact_CreatedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Artefakt "${i?.name}" erfolgreich erstellt`)
	return /** @type {LocalizedString} */ (`Artifact "${i?.name}" created successfully`)
});